// src/App.tsx
import React, { useState } from 'react';
import { buscarPorCpf } from './api/metaService';
import Tabs, { Tab } from './components/Tabs';

const App: React.FC = () => {
  const [cpf, setCpf] = useState('');
  const [resultado, setResultado] = useState<any | null>(null);
  const [logs, setLogs] = useState<string[]>([]);
  const [tabAtual, setTabAtual] = useState<string>('Resultado');

  const formatCpfCnpjInput = (value: string): string => {
    const numeric = value.replace(/\D/g, '');
    if (numeric.length <= 11) {
      return numeric
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1-$2');
    } else {
      return numeric
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
    }
  };

  const formatarData = (data: string): string => {
    const obj = new Date(data);
    const dia = obj.getDate().toString().padStart(2, '0');
    const mes = (obj.getMonth() + 1).toString().padStart(2, '0');
    const ano = obj.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  const logar = (msg: string) => {
    setLogs((prev) => [...prev.slice(-1), `[${new Date().toLocaleTimeString()}] ${msg}`]);
  };

  const handleBuscar = async () => {
    if (!cpf) return;
    const somenteNumeros = cpf.replace(/\D/g, '');
    logar(`🔍 Buscando CPF: ${somenteNumeros}`);
    try {
      const dados = await buscarPorCpf(somenteNumeros);
      setResultado(dados);
      setTabAtual("Resultado Meta");
      logar(`✅ Dados encontrados para CPF: ${somenteNumeros}`);
    } catch {
      setResultado(null);
      setTabAtual("Resultado");
      logar(`❌ Erro ao buscar CPF: ${somenteNumeros}`);
    }
  };

  const renderResultado = () => {
    if (!resultado) {
      return <div className="text-gray-500">Nenhum dado disponível.</div>;
    }

    const {
      CPF,
      UF,
      DT_INCLUSAO,
      DT_ATUALIZACAO,
      ...consumos
    } = resultado;

    const col1: string[] = [], col2: string[] = [];
    Object.entries(consumos).forEach(([_, value], index) => {
      (index % 2 === 0 ? col1 : col2).push(`${value}`);
    });

    return (
      <div className="bg-white p-4 rounded shadow-md border mt-4 text-sm">
        <div className="grid grid-cols-2 gap-x-8 gap-y-2 mb-4 text-gray-700">
          <div><strong>CPF:</strong> {formatCpfCnpjInput(CPF)}</div>
          <div><strong>UF:</strong> {UF}</div>
          <div><strong>DATA INCLUSÃO:</strong> {formatarData(DT_INCLUSAO)}</div>
          <div><strong>DATA ATUALIZAÇÃO:</strong> {formatarData(DT_ATUALIZACAO)}</div>
        </div>
        <hr className="my-3" />
        <div className="grid grid-cols-2 gap-2">
          <div>
            {col1.map((item, idx) => (
              <div key={`col1-${idx}`} className="text-gray-600">• {item}</div>
            ))}
          </div>
          <div>
            {col2.map((item, idx) => (
              <div key={`col2-${idx}`} className="text-gray-600">• {item}</div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const tabs: Tab[] = [
    {
      label: resultado ? "Resultado Meta" : "Resultado",
      content: renderResultado()
    }
  ];

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <div className="max-w-3xl mx-auto p-6 w-full">
        <h1 className="text-2xl font-bold text-blue-600 mb-4">🔎 Buscador Inteligente</h1>
        <div className="flex gap-2 items-center mb-4">
          <input
            type="text"
            value={cpf}
            onChange={(e) => setCpf(formatCpfCnpjInput(e.target.value))}
            placeholder="Digite CPF ou CNPJ"
            maxLength={18}
            className="border border-gray-300 rounded px-3 py-2 w-full text-sm"
          />
          <button
            onClick={handleBuscar}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition text-sm"
          >
            Buscar CPF/CNPJ
          </button>
        </div>

        <Tabs
          tabs={tabs}
          activeTab={tabAtual}
          onTabChange={setTabAtual}
        />
      </div>

      <footer className="bg-black text-green-400 font-mono text-xs p-2 mt-auto">
        {logs.slice(-2).map((log, idx) => (
          <div key={idx}>{log}</div>
        ))}
      </footer>
    </div>
  );
};

export default App;
